import React from "react";
import data from "../../../data/professioni.json";
import _ from "lodash";

const RecapSlides = ({ professioneId, riduzioneImposte }) => {
  let professione = _.findKey(data.professioni, function (o) {
    return o.id === parseInt(professioneId);
  });
  const selected = data.professioni[professione];
  const imposta = riduzioneImposte !== "0" ? 5 : 15;
  return (
    <div className="p-4 text-left">
      <Item label={"Professione"} value={selected.nome} />
      <Item
        label={"Codice ATECO"}
        value={`${selected.codice_ateco} - ${selected.descrizione}`}
      />
      <Item label={"Tipologia contributi"} value={selected.tipologia} />
      <Item label={"Redditività"} value={`${selected.redditivita}%`} />
      <Item label={"Imposta"} value={`${imposta}%`} />
    </div>
  );
};

export default RecapSlides;

const Item = ({ label, value }) => {
  return (
    <div>
      <span>{label}</span>
      <span className="text-orange-400">{` ${value}`}</span>
    </div>
  );
};
